import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgOutlinedQuestion = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <circle cx={12} cy={12} r={10.5} stroke="currentColor" />
      <path
        fill="#3C3E41"
        fillRule="evenodd"
        d="M9 7.242c.189-.173.392-.336.609-.487a4.205 4.205 0 011.532-.658A4.49 4.49 0 0112.096 6c.471 0 .898.069 1.28.206.383.137.71.333.983.587.272.255.483.561.632.92.15.357.224.757.224 1.2 0 .425-.056.793-.169 1.103a3.155 3.155 0 01-.986 1.406l-.581.47c-.184.145-.342.29-.476.432a.929.929 0 00-.247.474l-.128.781a.5.5 0 01-.494.42h-.612a.5.5 0 01-.497-.446l-.1-.914a1.18 1.18 0 01.094-.7c.1-.2.233-.381.401-.546l.266-.244.296-.235c.207-.154.4-.319.581-.495a2.57 2.57 0 00.456-.596 1.59 1.59 0 00.185-.785c0-.369-.12-.663-.358-.881-.238-.218-.554-.327-.947-.327-.288 0-.53.033-.726.1a2.924 2.924 0 00-.507.223 5.947 5.947 0 00-.362.222.515.515 0 01-.283.101.48.48 0 01-.447-.277L9 7.242zm1.47 9.424c0-.185.032-.36.098-.525a1.294 1.294 0 01.676-.713 1.21 1.21 0 01.506-.105c.178 0 .346.035.503.104a1.283 1.283 0 01.68.714c.065.165.098.34.098.525a1.4 1.4 0 01-.099.528 1.32 1.32 0 01-.27.424 1.267 1.267 0 01-.912.382 1.238 1.238 0 01-.911-.382 1.321 1.321 0 01-.271-.424 1.4 1.4 0 01-.099-.528z"
        className="OutlinedQuestion_svg__OutlinedQuestion_svg__symbol"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgOutlinedQuestion.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgOutlinedQuestion;
